<style scoped>
#Layer_1 {
  z-index: 10000000;
}

.section__sectors__FixedHeight900 {
  height: 900px;
}

.u-bg--white__Sectors__ValueAdded {
  background-color: #f2f2f2;
}

.u-bg--white__Sectors__Cybersecurity {
  background-color: #f2f2f2;
}
</style>
<template>
  <div class="c-page u-relative">
    <section
      data-color="clear"
      class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel"
    >
      <div
        class="c-page__header o-wrapper--panel"
        :style="
          'transform:translateX(' +
            headerPageSize[2] +
            'px) translateY(' +
            headerPageSize[3] +
            'px) scale(' +
            headerPageSize[4] +
            ')'
        "
      >
        <img
          src="/static/HeadImages/FoodService.jpg"
          class="u-absolute u-pos-tl"
          :style="
            'width:' +
              headerPageSize[0] +
              'px; height:' +
              headerPageSize[1] +
              'px'
          "
        />
        <div class="c-puzzle o-wrapper--panel u-fit u-overflow-h">
            
          <div
            class="c-puzzle__piece u-absolute"
            style="background-color: rgb(255, 255, 255); opacity: 0.6;"
          ></div>
          <div
            class="c-puzzle__piece u-absolute"
            style="background-color: rgb(255, 255, 255); opacity: 0.6;"
          ></div>
        </div>
      </div>
      <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
        <div
          class="u-relative u-inline-block u-valign-middle u-marg-t-vh1of10 u-fit-w u-pad-l-w3of12 u-pad-l-w2of12@xl u-pad-r-w4of12 u-pad-r-w3of12@xl u-pad-x-w1of12@sm"
        >
          <h1
            class="t-h2-main-title-marine-holdings c-page__subtitle t-text--base-bold  t-text-lh--md u-color--black"
            v-html="content.title"
          ></h1>
          <div class="introduction__inner">
            <div class="introduction__borderLeft scroll">
              <div class="scroll">
                <span class="background"></span>
                <span class="triangle"></span>
                <span class="label u-color--white">
                  <!--<app-push-button :visible="isButtonVisible" :isIntro="!0" :active="isButtonActive" :to="{ name: '/'}" :text="uiexplore" >{{uiexplore}}</app-push-button>-->Scroll
                  to discover</span
                >
              </div>
            </div>
            <div class="introduction__titles">
              <div class="introduction__titlesInner">
                <div class="introduction__subtitle">
                  <h1
                    class="t-h4 t-text--roman t-text-lh--md u-color--black"
                  >
                    <!-- <app-animated-text :text="contentNavalVessel.smalldescriptioon" :active="!0" ></app-animated-text>-->
                    <app-sliced-text
                      :content="content.subtitle"
                    ></app-sliced-text>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      :data-color="item.dataColor"
      v-for="(item, index) in content.blocks"
      class="u-relative u-overflow-h u-fit-w  u-pad-x-w2of12  u-pad-x-w1of12@sm   js-header-panel"
      :class="[item.bgColorClass]"
    >
      <div v-if="index === 0" class="u-absolute u-pos-tl u-fit">
        <div
          class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm  u-w3of4@sm"
        >
          <img
            src="../../assets/medias/images/services/Weeding-Salameh.jpg"
            class="u-fit-w"
          />
        </div>
      </div>
      <div v-if="index === 1" class="u-absolute u-pos-tl u-fit">
        <div
          class="c-investors__section-2__pattern u-absolute u-pos-tl u-w2of5 u-marg-b-0@sm  u-w3of4@sm"
        >
          <img
            src="../../assets/medias/images/services/corporate-events-salameh.jpg"
            class="u-fit-w"
          />
        </div>
      </div>
      <div v-if="index === 2" class="u-absolute u-pos-tl u-fit">
        <div
          class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm  u-w3of4@sm"
        >
          <img
            src="../../assets/medias/images/services/PRIVATE-OCCASIONS.jpg"
            class="u-fit-w"
          />
        </div>
      </div>
      <div v-if="index === 3" class="u-absolute u-pos-tl u-fit">
        <div
          class="c-investors__section-2__pattern u-absolute u-pos-tl u-w2of5 u-marg-b-0@sm  u-w3of4@sm"
        >
          <img
            src="../../assets/medias/images/services/community-catering.jpg"
            class="u-fit-w"
          />
        </div>
      </div>
      <div v-if="index === 4" class="u-absolute u-pos-tl u-fit">
        <div
          class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm  u-w3of4@sm"
        >
          <img
            src="../../assets/medias/images/services/BIRTHDAY-EVENTS.jpg"
            class="u-fit-w"
          />
        </div>
      </div>
      <!--
            <div v-if="index===5"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute u-pos-tl u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                     <img src="../../assets/medias/images/services/managment-services-marinholdings.jpg" class="u-fit-w" >
                   </div>
             </div>
             -->
      <span
        v-if="index < content.blocks.length - 1"
        class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"
      ></span>
      <div
        class="c-investors__section u-relative u-flex  u-flex-fd--column@sm u-pad-y-xxlfirst@sm u-pad-y-xxl@smsm u-pad-y-xlservices u-zindex--2"
        v-if="item.special === 'special-left'"
      >
        <div
          class="u-marg-b-xxl  u-w5of8 u-w1of2@md u-marg-l-w1of12@sm u-pad-l-0@lg u-fit-w@sm"
          :class="{ 'u-pad-l-w1of8': item.padLeft === '1' }"
        >
          <div>
            <app-scroll-object
              :offset="0.05"
              :isParallax="!1"
              inline-template
              :content="item"
            >
              <h3
                class="t-h4 t-text--roman u-relative u-marg-r-lg    u-marg-r-0@sm"
                :class="{
                  'u-color--brand-dark': item.color === 'dark',
                  'u-color--white': item.color === 'white',
                }"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.title"
                ></app-words>
              </h3>
            </app-scroll-object>
          </div>
          <div :key="indexin" v-for="(itemin, indexin) in item.content">
            <h6
              class=" t-text--md u-pad-t-lg "
              v-if="'title' === itemin.type.value"
              :class="{
                't-text--md--bold': itemin.bold === 'true',
                'u-color--brand-dark': itemin.color === 'dark',
                'u-color--white': itemin.color === 'white',
                'u-color--gray': itemin.color === 'gray',
              }"
            >
              <app-scroll-object
                :offset="0.05"
                :isParallax="!1"
                inline-template
                :content="itemin"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.content"
                ></app-words>
              </app-scroll-object>
            </h6>
            <div
              class="u-marg-t-md t-text--xl t-text-lh--md "
              v-if="'default' === itemin.type.value"
              :class="{
                'u-marg-t-md': indexin > 0,
                'u-color--gray': itemin.color === 'dark',
                'u-color--white': itemin.color === 'white',
              }"
              v-html="itemin.content"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="c-investors__section u-relative u-flex u-flex-fd--column@sm u-pad-y-xxlsecond@sm u-pad-y-xxl@smsm u-pad-y-xlservices"
        v-if="item.special === 'special-right'"
      >
        <div class="u-w3of8 u-w1of2@md u-fit-w@sm">
          <h3
            class="t-h4 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm"
          ></h3>
        </div>
        <div
          class="u-marg-t-xl@sm u-marg-b-md u-w5of8 u-w1of2@md u-pad-l-w1of8 u-pad-l-0@lg u-fit-w@sm"
        >
          <div>
            <app-scroll-object
              :offset="0.05"
              :isParallax="!1"
              inline-template
              :content="item"
            >
              <h3
                class="t-h4 t-text--roman u-relative u-marg-r-lg   u-pad-b-md u-marg-r-0@sm"
                :class="{
                  'u-color--brand-dark': item.color === 'dark',
                  'u-color--white': item.color === 'white',
                }"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.title"
                ></app-words>
              </h3>
            </app-scroll-object>
          </div>
          <div :key="indexin" v-for="(itemin, indexin) in item.content">
            <h6
              class="t-text--xl t-text-lh--md  t-text--roman"
              v-if="'title' === itemin.type.value"
              :class="{
                'u-marg-t-lg': indexin > 0,
                'u-color--brand-dark': itemin.color === 'dark',
                'u-color--white': itemin.color === 'white',
                'u-color--gray': itemin.color === 'gray',
              }"
            >
              <app-scroll-object
                :offset="0.05"
                :isParallax="!1"
                inline-template
                :content="itemin"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.content"
                ></app-words>
              </app-scroll-object>
            </h6>
            <div
              class="u-marg-t-md t-text--xl t-text-lh--md "
              v-if="'default' === itemin.type.value"
              :class="{
                'u-marg-t-md': indexin > 0,
                'u-color--gray': itemin.color === 'dark',
                'u-color--white': itemin.color === 'white',
              }"
              v-html="itemin.content"
            ></div>
            <div v-if="'blockquote' === itemin.type.value">
              <app-scroll-object
                :offset="0"
                :isParallax="!1"
                inline-template
                :content="itemin"
              >
                <p
                  class="c-investors__section-1__blockquote u-relative u-marg-t-lg u-pad-t-lg t-text--xl t-text-lh--md t-text--roman-italic u-color--brand-blue"
                >
                  <span
                    class="c-line--x u-absolute u-pos-tl u-fit-w u-bg--brand-blue"
                  ></span>
                  <app-words
                    :isActive="isActive"
                    :delay="0"
                    :content="content.content"
                  ></app-words>
                </p>
              </app-scroll-object>
            </div>
          </div>
        </div>
      </div>
    </section>
    <app-footer
      :globalContent="globalContent"
      :adminContent="adminContent"
    ></app-footer>
  </div>
</template>

<script>
import AppFooter from "../app-footer/index.vue";
import AppScrollObject from "../app-scroll-object/index.vue";
import AppSlicedText from "../app-sliced-text/index.vue";
import AppRiskTools from "../app-sliced-text/index.vue";
export default {
  props: {
    debug: {
      type: Boolean,
      default: !1,
    },
    adminContent: {
      type: Object,
      default: function() {},
    },
    globalContent: {
      type: Object,
      default: function() {},
    },
    headerPageSize: {
      type: Array,
      default: function() {},
    },
  },
  components: {
    "app-footer": AppFooter,
    "app-scroll-object": AppScrollObject,

    "app-sliced-text": AppSlicedText,
    "app-risk-tools": AppRiskTools,
  },
  computed: {
    content: function() {
      return this.adminContent.en.pages.services;
    },
    myStylesTransform2() {
      return {
        transform:
          "translateX(" +
          this.headerPageSize[2] +
          "px) translateY(" +
          this.headerPageSize[3] +
          "px) scale(" +
          this.headerPageSize[4] +
          ")",
      };
    },
    myStylesWidthHeight() {
      return {
        width: this.headerPageSize[0] + "px",
        height: this.headerPageSize[1] / 2 + "px",
        //height: 400 + "px"
      };
    },
    myStylesWidthHeight11() {
      return {
        width: "1600px",
        height: "900px",
      };
    },
  },
  created: function() {
    this.eventHub.$on("resize", this.onResize);
  },
  destroyed: function() {
    this.eventHub.$off("resize", this.onResize);
  },
  mounted: function() {
    this.onResize(), this.eventHub.$emit("page:ready");
  },
  data: function() {
    return {
      //  imageHeadSrc: require('../../assets/medias/images/services/stock-7-1.jpg')
    };
  },
  methods: {
    onResize: function() {},
  },
};
</script>
